// src/pages/Home.jsx
import React from "react";
import Hero from "../components/Hero";
import { CategoriesSection, StaticFeaturesSection } from "../components/ProductCategories";
import MarqueeFlags from "../components/TargetCountries";
import Benefits from "../components/Benefits";
import Testimonials from "../components/Testimonials";
import OurAchievements from "../components/OurAchievements";
import Collection from "../components/Collection";


const Home = () => {
  return (
    <>
      <Hero />
            <h3 className="text-3xl md:text-4xl font-extrabold text-[#4b2e19] text-center mt-10 drop-shadow-sm">
        SHOP BY CATEGORY
      </h3>

      <CategoriesSection isHome={true} />
      <Benefits 
          image={{
            src: require("../assets/benefit1.png"),
            alt: "Healthy ingredients"
          }}
          imagePosition="right"
        />
        <Collection />
        <OurAchievements />
      <Benefits 
          image={{
            src: require("../assets/benefit22.png"),
            alt: "Healthy ingredients"
          }}
          imagePosition="left"
        />


      <Testimonials />
      <MarqueeFlags />


      {/* <ProductCategories /> */}
      {/* <FreshArrivals />
      <SuccessStory />
      <OurCollection />
      <CountryFlags />
      <SpecialDiscount />
      <Testimonials />
      <LatestArticles /> */}
      {/* <Features /> */}
    </>
  );
};

export default Home;
